"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MechanicsForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var form_style = __importStar(require("./MechanicsForm.module.scss"));
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
require("react-quill-new/dist/quill.snow.css");
require("@styles/overrides/quill_override.scss");
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var useKeyEnter_1 = require("@hooks/useKeyEnter");
var react_1 = require("react");
var MechanicsTag_1 = __importDefault(require("@components/Tags/MechanicsTag"));
var MechanicsTypeModal_1 = __importDefault(require("@components/Modal/MechanicsTypeModal"));
var PressKeyHint_1 = __importDefault(require("@components/Hints/PressKeyHint"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("@store/slices/modalSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
function MechanicsForm(_a) {
    var formData = _a.formData, setFormData = _a.setFormData, handleFormSubmit = _a.handleFormSubmit, t = _a.language;
    var inputRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(""), submitMessage = _b[0], setSubmitMessage = _b[1];
    var _c = (0, react_1.useState)(false), isTypeModalVisible = _c[0], setTypeModalVisibe = _c[1];
    var types = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsTypeSlice; }).types;
    var gddId = (0, react_redux_1.useSelector)(function (state) { return state.gddSlice.gdd; }).id;
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, useClearOnTime_1.default)({ setText: setSubmitMessage, text: submitMessage });
    (0, useKeyEnter_1.useKeyEnterWithInput)({
        func: function (e) { return handleSetExample(e); },
        inputRef: inputRef,
    });
    function setMechanicsType(value) {
        handleInputChange(value, "type_id");
    }
    function handleSetExample(e) {
        setFormData(function (prev) {
            // Проверяем, есть ли уже такая строка в массиве
            if (prev.examples.includes(e)) {
                return prev; // Если есть, просто возвращаем прежнее состояние
            }
            return __assign(__assign({}, prev), { examples: __spreadArray(__spreadArray([], prev.examples, true), [e], false) });
        });
    }
    function handleDeleteExample(id) {
        var filtered = formData.examples.filter(function (ex) { return ex !== id; });
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { examples: filtered });
        });
    }
    function handleInputChange(value, key) {
        setFormData(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[key] = value, _a));
        });
    }
    function submitForm(e) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, handleFormSubmit(e)];
                    case 2:
                        res = _a.sent();
                        if (res === false) {
                            setSubmitMessage(t.requiredError);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({
                            activeModal: modalSlice_2.ActiveModal.Info,
                            text: "Something went wrong",
                        }));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("form", { className: form_style.mechanic_form, onSubmit: submitForm, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: "grid", gridTemplateColumns: "6fr 6fr", gap: 20 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, style: { width: "100%" }, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "title", children: t.nameLabel }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-title", type: "text", id: "title", name: "title", value: formData.name, onChange: function (e) { return handleInputChange(e.target.value, "name"); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, style: { width: "100%" }, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "type", children: t.typeLabel }), (0, jsx_runtime_1.jsxs)("div", { style: {
                                            display: "grid",
                                            gridTemplateColumns: "7fr 5fr",
                                            gap: 10,
                                            alignItems: "center",
                                            alignContent: "center",
                                        }, children: [(0, jsx_runtime_1.jsxs)("select", { "data-testid": "test-type-select", value: formData.type_id || "null", onChange: function (e) {
                                                    handleInputChange(e.target.value, "type_id");
                                                }, children: [(0, jsx_runtime_1.jsx)("option", { value: "null", children: t.selectTypePlaceholder }), types.map(function (type) { return ((0, jsx_runtime_1.jsx)("option", { value: type.id, children: type.type }, type.id)); })] }), (0, jsx_runtime_1.jsx)("button", { "data-testid": "test-edit-types-btn", className: button_styles.create_btn, style: { width: "150px" }, type: "button", onClick: function () { return setTypeModalVisibe(true); }, children: t.editTypesButton })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "description", className: form_style.relative_label, children: t.examplesLabel }), (0, jsx_runtime_1.jsx)(PressKeyHint_1.default, {}), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-example-input", type: "text", style: { marginBottom: 10 }, ref: inputRef })] }), (0, jsx_runtime_1.jsx)("div", { className: form_style.form_group, children: formData.examples.length > 0 ? ((0, jsx_runtime_1.jsx)(MechanicsTag_1.default, { deleteTag: function (item) { return handleDeleteExample(item); }, items: formData.examples, renderItem: function (item) { return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: item }); } })) : null }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "description", children: t.descriptionLabel }), (0, jsx_runtime_1.jsx)("textarea", { id: "description", className: "edit", value: formData.description, onChange: function (e) {
                                    handleInputChange(e.target.value, "description");
                                } })] }), submitMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(form_style.form_group, " ").concat(form_style.error), children: submitMessage })) : null, (0, jsx_runtime_1.jsx)("div", { className: form_style.form_footer, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: button_styles.create_btn, "data-testid": "test-submit-form", children: t.saveButton }) })] }), isTypeModalVisible ? ((0, jsx_runtime_1.jsx)(MechanicsTypeModal_1.default, { isVisibe: isTypeModalVisible, setVisible: setTypeModalVisibe, setMechanicsType: setMechanicsType, currentType: formData.type_id })) : null] }));
}
